function userSpan(user){
	return $('<span/>').css({color: user.color}).text(user.name);
}

function sysmessageDiv(fmt){
	let $p = $('<div class="chat-msg msg-system msg-first">'
		+ '<div class="chat-msg-time"/>'
		+ '<div class="chat-msg-body"/>'
		+ '</div>'
	);

	$p.find('.chat-msg-time').text(getFmtDate(fmt.time));

	return $p;
}

function getFmtDate(time){
	let fulldate = false;

	if (time != undefined){
		let nd = new Date(time);
		let cd = new Date(Date.now());
		fulldate = cd.getDate() != nd.getDate() || cd.getMonth() != nd.getMonth();
	}

	if (fulldate){
		return Date.format('%d.%m.%y %H:%M:%S', time);
	} else {
		return Date.format('%H:%M:%S', time);
	}
}

module.exports = {
	userSpan,
	sysmessageDiv,
	getFmtDate,
};
